import SERVICE_BRANCHES from '../constants/serviceBranches';
export default {
  [SERVICE_BRANCHES.ARMY]: [
    {
      abbreviation: 'PV2',
      title: 'Private',
    },
    {
      abbreviation: 'PFC',
      title: 'Private First Class',
    },
    {
      abbreviation: 'SPC',
      title: 'Specialist',
    },
    {
      abbreviation: 'CPL',
      title: 'Corporal',
    },
    {
      abbreviation: 'SGT',
      title: 'Sergeant',
    },
    {
      abbreviation: 'SSG',
      title: 'Staff Sergeant',
    },
    {
      abbreviation: 'SFC',
      title: 'Sergeant First Class',
    },
    {
      abbreviation: 'MSG',
      title: 'Master Sergeant',
    },
    {
      abbreviation: '1SG',
      title: 'First Sergeant',
    },
    {
      abbreviation: 'SGM',
      title: 'Sergeant Major',
    },
    {
      abbreviation: 'CSM',
      title: 'Command Sergeant Major',
    },
    {
      abbreviation: 'SMA',
      title: 'Sergeant Major of the Army',
    },
    {
      abbreviation: '2LT',
      title: 'Second Lieutenant',
    },
    {
      abbreviation: '1LT',
      title: 'First Lieutenant',
    },
    {
      abbreviation: 'CPT',
      title: 'Captain',
    },
    {
      abbreviation: 'MAJ',
      title: 'Major',
    },
    {
      abbreviation: 'LTC',
      title: 'Lieutenant Colonel',
    },
    {
      abbreviation: 'COL',
      title: 'Colonel',
    },
    {
      abbreviation: 'BG',
      title: 'Brigadier General',
    },
    {
      abbreviation: 'MG',
      title: 'Major General',
    },
    {
      abbreviation: 'LTG',
      title: 'Lieutenant General',
    },
    {
      abbreviation: 'GEN',
      title: 'General',
    },
    {
      abbreviation: 'GA',
      title: 'General of the Army',
    },
  ],
  [SERVICE_BRANCHES.AIR_FORCE]: [
    {
      abbreviation: 'AB',
      title: 'Airman Basic',
    },
    {
      abbreviation: 'Amn',
      title: 'Airman',
    },
    {
      abbreviation: 'A1C',
      title: 'Airman First Class',
    },
    {
      abbreviation: 'SrA',
      title: 'Senior Airman',
    },
    {
      abbreviation: 'SSgt',
      title: 'Staff Sergeant',
    },
    {
      abbreviation: 'TSgt',
      title: 'Technical Sergeant',
    },
    {
      abbreviation: 'MSgt',
      title: 'Master Sergeant',
    },
    {
      abbreviation: 'SMSgt',
      title: 'Senior Master Sergeant',
    },
    {
      abbreviation: 'CMSgt',
      title: 'Chief Master Sergeant',
    },
    {
      abbreviation: 'CCMSgt',
      title: 'Command Chief Master Sergeant',
    },
    {
      abbreviation: 'CMSAF',
      title: 'Chief Master Sergeant of the Air Force',
    },
    {
      abbreviation: '2nd Lt',
      title: 'Second Lieutenant',
    },
    {
      abbreviation: '1st Lt',
      title: 'First Lieutenant',
    },
    {
      abbreviation: 'Capt',
      title: 'Captain',
    },
    {
      abbreviation: 'Maj',
      title: 'Major',
    },
    {
      abbreviation: 'Lt Col',
      title: 'Lieutenant Colonel',
    },
    {
      abbreviation: 'Col',
      title: 'Colonel',
    },
    {
      abbreviation: 'Brig Gen',
      title: 'Brigadier General',
    },
    {
      abbreviation: 'Maj Gen',
      title: 'Major General',
    },
    {
      abbreviation: 'Lt Gen',
      title: 'Lieutenant General',
    },
    {
      abbreviation: 'Gen',
      title: 'General',
    },
    {
      abbreviation: 'GAF',
      title: 'General of the Air Force',
    },
  ],
  [SERVICE_BRANCHES.NAVY]: [
    {
      abbreviation: 'SR',
      title: 'Seaman Recruit',
    },
    {
      abbreviation: 'SA',
      title: 'Seaman Apprentice',
    },
    {
      abbreviation: 'SN',
      title: 'Seaman',
    },
    {
      abbreviation: 'PO3',
      title: 'Petty Officer Third Class',
    },
    {
      abbreviation: 'PO2',
      title: 'Petty Officer Second Class',
    },
    {
      abbreviation: 'PO1',
      title: 'Petty Officer First Class',
    },
    {
      abbreviation: 'CPO',
      title: 'Chief Petty Officer',
    },
    {
      abbreviation: 'SCPO',
      title: 'Senior Chief Petty Officer',
    },
    {
      abbreviation: 'MCPO',
      title: 'Master Chief Petty Officer',
    },
    {
      abbreviation: 'CMDCM',
      title: 'Command Master Chief Petty Officer',
    },
    {
      abbreviation: 'FLTCM',
      title: 'Fleet Master Chief Petty Officer',
    },
    {
      abbreviation: 'FORCM',
      title: 'Force Master Chief Petty Officer',
    },
    {
      abbreviation: 'MCPON',
      title: 'Master Chief Petty Officer of the Navy',
    },
    {
      abbreviation: 'ENS',
      title: 'Ensign',
    },
    {
      abbreviation: 'LTJG',
      title: 'Lieutenant Junior Grade',
    },
    {
      abbreviation: 'LT',
      title: 'Lieutenant',
    },
    {
      abbreviation: 'LCDR',
      title: 'Lieutenant Commander',
    },
    {
      abbreviation: 'CDR',
      title: 'Commander',
    },
    {
      abbreviation: 'CAPT',
      title: 'Captain',
    },
    {
      abbreviation: 'RDML',
      title: 'Rear Admiral Lower Half',
    },
    {
      abbreviation: 'RADM',
      title: 'Rear Admiral',
    },
    {
      abbreviation: 'VADM',
      title: 'Vice Admiral',
    },
    {
      abbreviation: 'ADM',
      title: 'Admiral',
    },
    {
      abbreviation: 'FADM',
      title: 'Fleet Admiral',
    },
  ],
  [SERVICE_BRANCHES.MARINE_CORPS]: [
    {
      abbreviation: 'Pvt',
      title: 'Private',
    },
    {
      abbreviation: 'PFC',
      title: 'Private First Class',
    },
    {
      abbreviation: 'LCpl',
      title: 'Lance Corporal',
    },
    {
      abbreviation: 'Cpl',
      title: 'Corporal',
    },
    {
      abbreviation: 'Sgt',
      title: 'Sergeant',
    },
    {
      abbreviation: 'SSgt',
      title: 'Staff Sergeant',
    },
    {
      abbreviation: 'GySgt',
      title: 'Gunnery Sergeant',
    },
    {
      abbreviation: 'MSgt',
      title: 'Master Sergeant',
    },
    {
      abbreviation: '1stSgt',
      title: 'First Sergeant',
    },
    {
      abbreviation: 'MGySgt',
      title: 'Master Gunnery Sergeant',
    },
    {
      abbreviation: 'SgtMaj',
      title: 'Sergeant Major',
    },
    {
      abbreviation: 'SMMC',
      title: 'Sergeant Major of the Marine Corps',
    },
    {
      abbreviation: '2ndLt',
      title: 'Second Lieutenant',
    },
    {
      abbreviation: '1stLt',
      title: 'First Lieutenant',
    },
    {
      abbreviation: 'Capt',
      title: 'Captain',
    },
    {
      abbreviation: 'Maj',
      title: 'Major',
    },
    {
      abbreviation: 'LtCol',
      title: 'Lieutenant Colonel',
    },
    {
      abbreviation: 'Col',
      title: 'Colonel',
    },
    {
      abbreviation: 'BGen',
      title: 'Brigadier General',
    },
    {
      abbreviation: 'MajGen',
      title: 'Major General',
    },
    {
      abbreviation: 'LtGen',
      title: 'Lieutenant General',
    },
    {
      abbreviation: 'Gen',
      title: 'General',
    },
  ],
  [SERVICE_BRANCHES.SPACE_FORCE]: [
    {
      abbreviation: 'Spc3',
      title: 'Specialist 3',
    },
    {
      abbreviation: 'Spc4',
      title: 'Specialist 4',
    },
    {
      abbreviation: 'Spc5',
      title: 'Specialist 5',
    },
    {
      abbreviation: 'Spc6',
      title: 'Specialist 6',
    },
    {
      abbreviation: 'TSgt',
      title: 'Technical Sergeant',
    },
    {
      abbreviation: 'MSgt',
      title: 'Master Sergeant',
    },
    {
      abbreviation: 'SMSgt',
      title: 'Senior Master Sergeant',
    },
    {
      abbreviation: 'CMSgt',
      title: 'Chief Master Sergeant',
    },
    {
      abbreviation: 'CCMSgt',
      title: 'Command Chief Master Sergeant',
    },
    {
      abbreviation: 'CMSAF',
      title: 'Chief Master Sergeant of the Air Force',
    },
    {
      abbreviation: '2nd Lt',
      title: 'Second Lieutenant',
    },
    {
      abbreviation: '1st Lt',
      title: 'First Lieutenant',
    },
    {
      abbreviation: 'Capt',
      title: 'Captain',
    },
    {
      abbreviation: 'Maj',
      title: 'Major',
    },
    {
      abbreviation: 'Lt Col',
      title: 'Lieutenant Colonel',
    },
    {
      abbreviation: 'Col',
      title: 'Colonel',
    },
    {
      abbreviation: 'Brig Gen',
      title: 'Brigadier General',
    },
    {
      abbreviation: 'Maj Gen',
      title: 'Major General',
    },
    {
      abbreviation: 'Lt Gen',
      title: 'Lieutenant General',
    },
    {
      abbreviation: 'Gen',
      title: 'General',
    },
    {
      abbreviation: 'GAF',
      title: 'General of the Air Force',
    },
  ],
  [SERVICE_BRANCHES.COAST_GUARD]: [
    {
      abbreviation: 'SR',
      title: 'Seaman Recruit',
    },
    {
      abbreviation: 'SA',
      title: 'Seaman Apprentice',
    },
    {
      abbreviation: 'SN',
      title: 'Seaman',
    },
    {
      abbreviation: 'PO3',
      title: 'Petty Officer Third Class',
    },
    {
      abbreviation: 'PO2',
      title: 'Petty Officer Second Class',
    },
    {
      abbreviation: 'PO1',
      title: 'Petty Officer First Class',
    },
    {
      abbreviation: 'CPO',
      title: 'Chief Petty Officer',
    },
    {
      abbreviation: 'SCPO',
      title: 'Senior Chief Petty Officer',
    },
    {
      abbreviation: 'MCPO',
      title: 'Master Chief Petty Officer',
    },
    {
      abbreviation: 'CMDCM',
      title: 'Command Master Chief Petty Officer',
    },
    {
      abbreviation: 'MCPON',
      title: 'Master Chief Petty Officer of the Navy',
    },
    {
      abbreviation: 'ENS',
      title: 'Ensign',
    },
    {
      abbreviation: 'LTJG',
      title: 'Lieutenant Junior Grade',
    },
    {
      abbreviation: 'LT',
      title: 'Lieutenant',
    },
    {
      abbreviation: 'LCDR',
      title: 'Lieutenant Commander',
    },
    {
      abbreviation: 'CDR',
      title: 'Commander',
    },
    {
      abbreviation: 'CAPT',
      title: 'Captain',
    },
    {
      abbreviation: 'RDML',
      title: 'Rear Admiral Lower Half',
    },
    {
      abbreviation: 'RADM',
      title: 'Rear Admiral',
    },
    {
      abbreviation: 'VADM',
      title: 'Vice Admiral',
    },
    {
      abbreviation: 'ADM',
      title: 'Admiral',
    },
    {
      abbreviation: 'FADM',
      title: 'Fleet Admiral',
    },
  ],
};
